"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AuthorizedSignerModal_1 = __importDefault(require("../components/AuthorizedSignerModal"));
function AddSigner() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "add-signer-page", children: (0, jsx_runtime_1.jsx)(AuthorizedSignerModal_1.default, { isOpen: true, setIsOpen: () => { }, withModal: false, subtitle: "Please provide the authorized signer details below.", isOnAddSignerPage: true }) }));
}
exports.default = AddSigner;
